import { HeaderAction } from "./headerAction";
import { BuybackHeaderAction } from "./buybackHeaderAction";

export class HeaderButton {
  isButtonLoading: boolean;
  headerAction: HeaderAction | null;
  buybackHeaderActions: BuybackHeaderAction[];

  constructor(
    isButtonLoading: boolean = false,
    headerAction: HeaderAction | null = null,
    buybackHeaderActions: BuybackHeaderAction[] = []
  ) {
    this.isButtonLoading = isButtonLoading;
    this.headerAction = headerAction;
    this.buybackHeaderActions = buybackHeaderActions;
  }

  setIsButtonLoading(isButtonLoading: boolean): void {
    this.isButtonLoading = isButtonLoading;
  }

  setHeaderAction(headerAction: HeaderAction): void {
    this.headerAction = headerAction;
  }

  setBuybackActions(actions: BuybackHeaderAction[]): void {
    this.buybackHeaderActions = actions;
  }

  getBuybackAction(actionKey: string): BuybackHeaderAction | undefined {
    return this.buybackHeaderActions.find((action) => action.key === actionKey);
  }

  activateBuybackActions(actionKeys: string[]): void {
    actionKeys.forEach((actionKey) => {
      const action = this.getBuybackAction(actionKey);
      if (action) {
        action.activate();
      }
    });
  }

  updateAction(actionKey: string, newData: Partial<BuybackHeaderAction>): void {
    const action = this.getBuybackAction(actionKey);
    if (action) {
      action.update(newData);
    }
  }

  isAnyActionActive(): boolean {
    return this.buybackHeaderActions?.some((action) => action.isActive());
  }
}
